module.exports = __webpack_public_path__ + "static/media/Kosovo-flag.7aee26d6.svg";